import Accordion from "./accordion"
import Alert from "./alert"
import Avatar from "./avatar"
import Badge from "./badge"
import Button from "./button"
import Checkbox from "./checkbox"
import CloseButton from "./close-button"
import Code from "./code"
import Divider from "./divider"
import Modal from "./modal"
import Heading from "./heading"
import Icon from "./icon"
import Input from "./input"
import InputAddon from "./input-addon"
import Link from "./link"
import Menu from "./menu"
import NumberInput from "./number-input"
import Radio from "./radio"
import Slider from "./slider"
import Select from "./select"
import Spinner from "./spinner"
import Switch from "./switch"
import Tabs from "./tabs"
import Tag from "./tag"
import Tooltip from "./tooltip"
import Kbd from "./kbd"
import PinInput from "./pin-input"
import Popover from "./popover"
import Form from "./form"
import Editable from "./editable"
import Progress from "./progress"
import Textarea from "./textarea"
import Stat from "./stat"
import Skeleton from "./skeleton"

export default {
  Accordion,
  Button,
  Heading,
  Icon,
  Alert,
  Badge,
  Avatar,
  Link,
  Code,
  Divider,
  Spinner,
  Menu,
  Tabs,
  Checkbox,
  Radio,
  Input,
  InputAddon,
  Tooltip,
  CloseButton,
  Slider,
  NumberInput,
  Switch,
  Tag,
  Modal,
  Kbd,
  Select,
  Textarea,
  PinInput,
  Popover,
  Form,
  Editable,
  Progress,
  Stat,
  Skeleton,
}
